import React from 'react';
import { Button, Center, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconConfetti } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

export const OnboardingSuccess: React.FC<{ onGoToSyncs?: () => void }> = ({ onGoToSyncs }) => {
    const { t } = useTranslation(['app']);

    return (
        <Center py="xl">
            <Stack align="center" gap="lg" maw={400}>
                <ThemeIcon size={80} radius="xl" variant="light" color="green">
                    <IconConfetti size={40} />
                </ThemeIcon>
                <Text size="xl" fw={700} ta="center">{t('dashboard.onboarding.success.title')}</Text>
                <Text c="dimmed" ta="center">{t('dashboard.onboarding.success.description')}</Text>
                {onGoToSyncs && (
                    <Button onClick={onGoToSyncs}>{t('dashboard.onboarding.success.cta')}</Button>
                )}
            </Stack>
        </Center>
    );
};
